<div class="dealer-portal-right-section" id="dealer-portal-right">
    
    <div class="newsletter" *ngIf="categoryList?.length>0">
        <div class="title flex items-center">
            <span class="w-2 h-5 bg-[#007BC0] mr-2"></span>
            {{ "NEWSLETTER" | translate }}
        </div>
        <div class="newsletter__list">
            <div class="newsletter__item" *ngFor="let item of categoryList" (click)="viewPdf(item)">
                <img class="newsletter__item-img" [src]="'data:image/jpg;base64,'+ item.imageBase64" alt="">
                <div class="newsletter__item-section">
                    <div class="newsletter__item-title">{{ item.title }}</div>
                    <div class="newsletter__item-desc">{{ item.content }}</div>
                    <div *ngIf="item.tagsVOList?.length > 0">
                        <nz-tag 
                            [nzColor]="'#79BBF1'"
                            class="max-w-20 overflow-hidden text-ellipsis text-black" 
                            *ngFor="let data of item.tagsVOList"  
                        > {{ data.tagName }}</nz-tag>
                    </div>
                    <div class="newsletter__item-time">{{ item.createTime }}</div>
                </div>
            </div>
            <div class="newsletter__view-more" *ngIf="hasMoreNews" (click)="getMoreNewsletter()">View More</div>
            <div class="newsletter__view-more" *ngIf="categoryList?.length>3" (click)="restoreNewsletter()">Restore</div>
        </div>
    </div>
    <div class="related-platforms">
        <div class="title flex items-center">
            <span class="w-2 h-5 bg-[#007BC0] mr-2"></span>
            {{ "RELATED_PLATFORMS" | translate }}
        </div>
        <div class="related-platforms__list">
            <div class="related-platforms__item" (click)="linkPlatform(platform.url)" *ngFor="let platform of platformList">
                <svg-icon [iconName]="platform.icon" [size]="40" class="mr20"></svg-icon>
                <div class="related-platforms__item-section">
                    <div class="related-platforms__item-title">{{platform.title}}</div>
                    <div class="related-platforms__item-desc">{{platform.desc}}</div>
                </div>
            </div>
        </div>
    </div>
</div>